import { render, staticRenderFns } from "./FileFlagStatusChip.vue?vue&type=template&id=fbc07616"
import script from "./FileFlagStatusChip.vue?vue&type=script&lang=ts"
export * from "./FileFlagStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports